import { render, staticRenderFns } from "./ShopCategories.vue?vue&type=template&id=66827232&scoped=true"
import script from "./ShopCategories.vue?vue&type=script&lang=js"
export * from "./ShopCategories.vue?vue&type=script&lang=js"
import style0 from "./ShopCategories.vue?vue&type=style&index=0&id=66827232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66827232",
  null
  
)

export default component.exports